var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDowngradeSuccessIcon = function SvgDowngradeSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 120h120V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116DFF",
    d: "M82 110 60 95l-22 15V67h44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192C55",
    d: "m31.132 88.028.747.665-5.417 6.084-.747-.665 5.417-6.084Zm57.736 0 5.417 6.084-.747.665-5.417-6.084.747-.665ZM26.385 78.33l.587.81L7.566 93.22l-.587-.81 19.406-14.08Zm67.23 0 19.406 14.08-.587.81-19.406-14.08.587-.81ZM22.26 67.931l.527.85-14.434 8.955-.526-.85 14.432-8.955Zm75.479 0 14.433 8.955-.528.85-14.432-8.955.527-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB6AC",
    d: "m106.82 30.886 9.438 3.393-1.015 2.823-9.437-3.393 1.015-2.823ZM8.417 7.442l6.493 7.643-2.286 1.942L6.13 9.384l2.286-1.942Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2E2FF",
    d: "m21.187 25.899 1.015 2.824-9.436 3.393-1.015-2.823 9.436-3.394Zm76.585-9.87 2.597 1.502-5.022 8.68-2.597-1.503 5.022-8.68Zm8.717-11.645 6.587 7.505-2.255 1.979-6.587-7.505 2.255-1.98Zm-75.474-.71 2.239 1.995-6.673 7.485-2.24-1.996 6.674-7.485Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38 65.84v1.39C43.74 72.66 51.49 76 60 76s16.26-3.34 22-8.77v-1.39c-.47.48-43.53.48-44 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M60 71.5c-15.164 0-27.5-12.336-27.5-27.5S44.836 16.5 60 16.5 87.5 28.836 87.5 44 75.164 71.5 60 71.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28BF9A",
    d: "M56.56 55.647 45.323 45.22l3.401-3.666 7.547 7.004L71.133 32.32l3.689 3.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116DFF",
    d: "M60 13c-17.121 0-31 13.879-31 31 0 17.121 13.879 31 31 31 17.121 0 31-13.879 31-31 0-17.121-13.879-31-31-31m0 7c13.233 0 24 10.766 24 24S73.233 68 60 68 36 57.234 36 44s10.767-24 24-24"
  }))));
};
export default SvgDowngradeSuccessIcon;